import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import AppContainer from './components/AppContainer';
import ClientLayout from './components/Portal/ClientLayout';
import AddLedger from './components/XPA/AddLedger';
import DisplayNotifications from './components/Common/DisplayNotifications';
import DisplayError from './components/Common/DisplayError';
import BankFeedContainer from './components/XPA/BankFeedResponse';
import BankFeedManagmentContainer from './components/FeedManagment/BankFeedManagment';
import Login from './components/Portal/Login';
import OpenBanking from './components/FeedManagment/OpenBanking';
import Logout from './components/Portal/Logout';
import SetPassword from './components/Portal/SetPassword';
import PayPalAuth from './components/FeedManagment/PayPalAuth';
import BnzAccounts from './components/FeedManagment/BnzSelectAccounts';
import FastLinkCallBack from './components/FeedManagment/FastLinkCallBack';
import FastlinkRedirect from './components/FeedManagment/FastLinkRedirect';
import ReactGA from 'react-ga';
import { TRACKING_CODE } from "./Actions/types";

ReactGA.initialize(TRACKING_CODE);
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {

	componentWillMount() {
		const data = JSON.parse(this.props.data);
		if (data && data.isR1) {
			localStorage.removeItem('token');
			localStorage.removeItem('bookid');
			localStorage.removeItem('cognitotoken');
			localStorage.removeItem('isr1');
			localStorage.removeItem("authtype")
			localStorage.removeItem('columnWidths');
		}

		if (data) {
			Object.keys(data).forEach(item => localStorage.setItem(item.toLowerCase(), data[item]));
		}
	}

	render() {
		return <React.Fragment>
        <DisplayNotifications />
        <DisplayError />
        <Switch>
          <Route path="/xpa/addledger" component={AddLedger} />
          <Route path="/bfm" component={BankFeedManagmentContainer} />
          <Route path="/response/:error?" component={BankFeedContainer} />
          <Route path="/paypal" component={PayPalAuth} />
          <Route path="/fastlinkcallback" component={FastLinkCallBack} />
          <Route path="/fastlinktoken/:bookId" component={FastlinkRedirect} />
          <Route path="/bnz/:token/:userId/:bookId" component={BnzAccounts} />
          <Route path="/:bookid/Core/Banking" component={AppContainer} />
          <Route path="/:bookid/Core/BankFeedManagement" component={BankFeedManagmentContainer} />
          <Route path="/openbanking" component={OpenBanking} />
          <Route path="/" exact component={AppContainer} />
          <ClientLayout>
            <Route path="/xpa" component={BankFeedManagmentContainer} />
            <Route path="/book/:bookid?" component={Login} />
            <Route path="/setPassword/:bookid/:username/:passwordResetToken" component={SetPassword} />
            <Route path="/logout" component={Logout} />
          </ClientLayout>
        </Switch>
      </React.Fragment>;
	}
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js